export interface AdvancedSettingsValue {
  vocalGender?: 'f' | 'm'
  styleWeight: number
  creativeWeight: number
  audioWeight: number
}

export const DEFAULT_ADVANCED_SETTINGS: AdvancedSettingsValue = {
  styleWeight: 0.5,
  creativeWeight: 0.5,
  audioWeight: 0.25,
}
